import type { AnalyticsEvent, ElementName } from "../types";

type TrackedClickEventParams = AnalyticsEvent & {
  element_name: ElementName;
  page_zone: string;
  lang: string;
};

function getTrackedClickEventBody<T extends ElementName>(params: {
  element_name: T;
  page_zone?: string;
}): TrackedClickEventParams & { element_name: T } {
  return {
    ...params,
    event: "tracked_click",
    lang: "en",
    page_zone: params.page_zone ?? "ppc",
  };
}

export { getTrackedClickEventBody };
